import {
  Home,
  BadgePoundSterling,
  Scale,
  Ship,
  HeartPulse,
  Smartphone,
  Car,
  Plane,
  PartyPopper,
  type LucideIcon,
} from 'lucide-react';

export type InsuranceProductType =
  | 'home_buildings'
  | 'pricing_renewals'
  | 'legal_expenses'
  | 'marine'
  | 'medical'
  | 'mobile_gadget'
  | 'motor'
  | 'travel'
  | 'wedding_events';

export interface ProductIconConfig {
  icon: LucideIcon;
  label: string;
  color: string;
  bgColor: string;
}

export const INSURANCE_PRODUCT_ICONS: Record<InsuranceProductType, ProductIconConfig> = {
  home_buildings: {
    icon: Home,
    label: 'Home and Buildings',
    color: 'text-blue-600',
    bgColor: 'bg-blue-50',
  },
  pricing_renewals: {
    icon: BadgePoundSterling,
    label: 'Pricing and Renewals',
    color: 'text-purple-600',
    bgColor: 'bg-purple-50',
  },
  legal_expenses: {
    icon: Scale,
    label: 'Legal Expenses',
    color: 'text-gray-700',
    bgColor: 'bg-gray-100',
  },
  marine: {
    icon: Ship,
    label: 'Marine',
    color: 'text-cyan-600',
    bgColor: 'bg-cyan-50',
  },
  medical: {
    icon: HeartPulse,
    label: 'Medical',
    color: 'text-red-600',
    bgColor: 'bg-red-50',
  },
  mobile_gadget: {
    icon: Smartphone,
    label: 'Mobile and Gadget',
    color: 'text-indigo-600',
    bgColor: 'bg-indigo-50',
  },
  motor: {
    icon: Car,
    label: 'Motor',
    color: 'text-orange-600',
    bgColor: 'bg-orange-50',
  },
  travel: {
    icon: Plane,
    label: 'Travel',
    color: 'text-sky-600',
    bgColor: 'bg-sky-50',
  },
  wedding_events: {
    icon: PartyPopper,
    label: 'Wedding and Events',
    color: 'text-pink-600',
    bgColor: 'bg-pink-50',
  },
};

/**
 * Get icon configuration for a product type
 */
export const getProductIcon = (productType: InsuranceProductType): ProductIconConfig => {
  return INSURANCE_PRODUCT_ICONS[productType] || INSURANCE_PRODUCT_ICONS.home_buildings;
};

/**
 * Get all product types for filters
 */
export const getAllProductTypes = (): Array<{ value: InsuranceProductType; label: string }> => {
  return Object.entries(INSURANCE_PRODUCT_ICONS).map(([value, config]) => ({
    value: value as InsuranceProductType,
    label: config.label,
  }));
};
